import React, { useState, useEffect } from "react";
import { Dropdown } from "antd";
import plus from "../../../assets/Images/plus.svg";
import menu from "../../../assets/Images/menudots.svg";
import Navbar from "../../../components/Navbar/Navbar";
import { EditOutlined, StopOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../../components/Loading";
import { toast } from "react-toastify";
import { GetRetailerDetails } from "../../../API  Functions/ProfileFunctions";
import { checkPermission } from "../../../Utils/permissionHelper";
import SearchBox from "../../../components/CustomWidgets/SearchBox";
import {
  createDeliveryBoy,
  getAllDeliveryBoys,
  updateDeliveryBoy,
} from "../../../API  Functions/DeliveryBoyApis";
import { Modal, Input } from "antd";
import { InputBox } from "../../../components/CustomWidgets/InputBox";
import FlagIcon from "../../../assets/egypt.svg";

const DeliveryBoy = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector(
    (state) => state.login?.user?.result?.company_id,
  );
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin,
  );

  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [deliveryBoyData, setDeliveryBoyData] = useState([]);
  const [allDeliveryBoyData, setAllDeliveryBoyData] = useState([]);
  const [retailerData, setretailerData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deliveryBoyName, setDeliveryBoyName] = useState("");
  const [deliveryBoyPhone, setDeliveryBoyPhone] = useState("");
  const [editDeliveryBoyID, setEditDeliveryBoyID] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    fetchdetails();
    GetDeliveryBoyData();
  }, []);

  const GetDeliveryBoyData = async () => {
    try {
      setLoading(true);
      const payload = {
        company_id: store_id,
        search: "",
        limit: 100,
        offset: 0,
      };
      const res1 = await getAllDeliveryBoys(store_id, payload);

      if (res1?.result?.status_code === 200) {
        const activeUsers = res1.result?.data;
        setDeliveryBoyData(activeUsers);
        console.log("ACTIVE USERS", activeUsers)
        setAllDeliveryBoyData(activeUsers);
      } else {
        setDeliveryBoyData([]);
      }
    } catch (error) {
      console.error("Error fetching delivery boy data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result?.retailer_details);
      }
    });
  };

  const searchDeliveryBoy = (searchText) => {
    if (!searchText || searchText.trim() === "") {
      setDeliveryBoyData(allDeliveryBoyData); // reset when empty
      return;
    }

    const text = searchText.toLowerCase();

    const filteredUsers = allDeliveryBoyData.filter((user) => {
      const name =
        typeof user?.name === "string" ? user.name.toLowerCase() : "";
      const deliveryBoyNo =
        typeof user?.delivery_boy_no === "string"
          ? user.delivery_boy_no.toLowerCase()
          : "";
      const phone =
        typeof user?.phone_no === "string" ? user.phone_no.toLowerCase() : "";
      const id =
        user?.id

      return (
        name.includes(text) ||
        deliveryBoyNo.includes(text) ||
        phone.includes(text));
    });

    setDeliveryBoyData(filteredUsers);
  };

  const getMaxLength = (mobile) => {
    return mobile?.startsWith("0") ? 11 : 10;
  };

  const handleAddDeliveryBoy = async () => {
    if (isSaving) return;
    if (!deliveryBoyName || !deliveryBoyPhone) {
      toast.error(t("Please enter name and phone number"));
      return;
    }
    let phoneNumber = deliveryBoyPhone?.replace(/^0+/, "");
    if (phoneNumber?.length < 10) {
      toast.error(t("Invalid phone number"));
      return;
    }
    try {
      setIsSaving(true);

      const payload = {
        company_id: store_id,
        name: deliveryBoyName?.trim(),
        phone_no: phoneNumber,
      };

      const res1 = await createDeliveryBoy(store_id, payload);

      if (res1.result.status_code == 200) {
        toast.success(t("Delivery boy added successfully"));
        setIsModalOpen(false);
        setDeliveryBoyName("");
        setDeliveryBoyPhone("");
        GetDeliveryBoyData();
      } else {
        if (
          res1.result.status_code == 400 &&
          res1.result.status?.includes("already exists")
        ) {
          toast.error(t("Delivery boy already exist with this number"));
        } else {
          toast.error(t(res1.result.status));
        }
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setIsSaving(false);
    }
  };

  const handleUpdateDeliveryBoy = async () => {
    if (isSaving) return;

    if (!deliveryBoyName || !deliveryBoyPhone) {
      toast.error(t("Please enter name and phone number"));
      return;
    }
    let phoneNumber = deliveryBoyPhone?.replace(/^0+/, "");
    if (phoneNumber?.length < 10) {
      toast.error(t("Invalid phone number"));
      return;
    }

    try {
      setIsSaving(true);

      const payload = {
        company_id: store_id,
        delivery_boy_id: editDeliveryBoyID,
        name: deliveryBoyName?.trim(),
        phone_no: phoneNumber,
        is_delete: false,
      };

      const res1 = await updateDeliveryBoy(store_id, payload);

      if (res1.result.status_code == 200) {
        toast.success(t("Delivery boy updated successfully"));
        setIsModalOpen(false);
        setDeliveryBoyName("");
        setDeliveryBoyPhone("");
        setEditDeliveryBoyID("");
        GetDeliveryBoyData();
      } else {
        if (
          res1.result.status_code == 400 &&
          res1.result.status?.includes("already exists")
        ) {
          toast.error(t("Delivery boy already exist with this number"));
        } else {
          toast.error(t(res1.result.status));
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteDeliveryBoy = async (id) => {
    try {
      const payload = {
        company_id: store_id,
        delivery_boy_id: id,
        name: "",
        phone_no: "",
        is_delete: true,
      };

      const res1 = await updateDeliveryBoy(store_id, payload);

      if (res1.result.status_code == 200) {
        toast.success(t("Delivery boy deleted successfully"));
        GetDeliveryBoyData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="w-full flex flex-col pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="All Delivery Boys" />
        <div className="overflow-y-auto custom-scrollbar">
          <div className="me-4 ms-3 font-extrabold">
            {retailerData?.status == "approved" ? (
              <>
                <div className="flex flex-col md:flex-row items-end justify-between mt-5 md:mt-0">
                  <SearchBox
                    searchResult={(values) => searchDeliveryBoy(values)}
                    placeholder={t("Search Delivery Boy")}
                  />

                  <div className="flex justify-between items-center">
                    <div className="font-semibold text-xl mt-2 "></div>
                    <button
                      onClick={() => {

                        setIsModalOpen(true);

                      }}
                      className={`font-semibold w-44 mt-5  h-10 border  rounded-lg bg-primaryBlue text-white text-sm   flex justify-center items-center gap-2`}
                      type="submit"
                    >
                      <img src={plus} alt="plus" />
                      <p className="">{t("Add Delivery Boy")}</p>
                    </button>
                  </div>
                </div>
                <div className="mt-3 ms-2">
                  {deliveryBoyData?.length > 0 ? (
                    <div className="font-semibold text-xl mt-2">
                      {t("All Delivery Boys")}{" "}
                      <span>{`(${deliveryBoyData?.length})`}</span>
                    </div>
                  ) : (
                    <div className="flex justify-center w-full mt-16 text-sm text-body text-center p-3 font-normal ">
                      {t("No delivery boy found.")}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 mb-4">
                  {deliveryBoyData.map((val, i) => (
                    <div
                      key={i}
                      className="w-[345px] md:w-full h-30 shadow-sm hover:shadow-lg rounded-xl bg-[#FFFFFF] mt-4 p-3"
                    >
                      <div className="relative flex items-start justify-between">
                        {/* Status Dot */}
                        <div className="absolute top-0 start-1">
                          <span
                            className={`h-3 w-3 rounded-full block ${val?.is_delete === false
                                ? "bg-green-500"
                                : "bg-red-500"
                              }`}
                          />
                        </div>

                        {/* User Info */}
                        <div className="ms-7">
                          <div className="font-medium text-[#272728] text-lg">
                            {val.name}
                          </div>
                          <div className="text-[#8A8A8A] text-base font-semibold tracking-wide">
                            {`${t("Delivery Boy ID:")} ${val.delivery_boy_no}`}
                          </div>
                          <div className="text-[#8A8A8A] text-base font-semibold tracking-wide">
                            {val.phone_no}
                          </div>
                        </div>

                        {/* Menu */}
                        {!val.is_deleted && (
                          <Dropdown
                            menu={{
                              items: [
                                {
                                  key: "1",
                                  icon: <EditOutlined />,
                                  label: t("edit"),
                                  onClick: () => {
                                    console.log("Delivery_boy", val)
                                    setDeliveryBoyName(val.name);
                                    setDeliveryBoyPhone(val.phone_no);
                                    setEditDeliveryBoyID(val.id);
                                    setIsEdit(true);
                                    setIsModalOpen(true);
                                  },
                                },
                                { type: "divider" },
                                {
                                  key: "2",
                                  icon: <StopOutlined />,
                                  label: t("Delete"),
                                  onClick: () => {
                                    handleDeleteDeliveryBoy(
                                      val.id,
                                    );
                                  },
                                },
                              ],
                            }}
                            trigger={["click"]}
                            placement="bottomRight"
                            arrow
                          >
                            <img
                              src={menu}
                              alt="menu"
                              className="w-5 h-5 cursor-pointer "
                            />
                          </Dropdown>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="flex justify-center w-full mt-16 text-sm text-body text-center p-3 font-normal ">
                  {retailerData?.status && retailerData?.status != "approved"
                    ? t(
                      "You cannot add or update delivery boy settings until your store is approved by myGINNE.",
                    )
                    : ""}
                </div>
              </>
            )}
          </div>
        </div>
        <Modal
          title={isEdit ? t("Update Delivery Boy") : t("Add Delivery Boy")}
          open={isModalOpen}
          onCancel={() => {
            setDeliveryBoyName("");
            setDeliveryBoyPhone("");
            setEditDeliveryBoyID(null);
            setIsEdit(false);
            setIsModalOpen(false);
          }}
          onOk={() => {
            if (isEdit) {
              handleUpdateDeliveryBoy();
            } else {
              handleAddDeliveryBoy();
            }
          }}
          okText={t("Save")}
          cancelText={t("Cancel")}
          confirmLoading={isSaving}
          okButtonProps={{
            disabled:isSaving,
            style: {
              backgroundColor: "#1b4597",
              borderColor: "#1b4597",
              color: "#fff",
            },
          }}
        >
          <div className="flex flex-col gap-5 mt-2 mb-2">
            {/* Name */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 -mb-1">
                {t("Name")}
              </label>

              <InputBox
                name="first_name"
                placeholder={t("Enter Name")}
                value={deliveryBoyName}
                maxLength={40}
                onChange={(e) => setDeliveryBoyName(e.target.value)}
                className="h-11 rounded-lg border-gray-300 focus:border-primaryBlue focus:ring-1 focus:ring-primaryBlue"
              />
            </div>

            {/* Mobile Number */}
            <div className="flex flex-col mb-2">
              <label
                className={`text-sm font-medium text-gray-700 mb-1 ${i18n.language === "ar" ? "text-right" : ""
                  }`}
              >
                {t("Mobile Number")}
              </label>

              <div className="flex items-center gap-2">
                {/* Flag */}
                <div className="h-11 min-w-[60px] flex items-center justify-center rounded-lg border border-gray-300 bg-gray-50">
                  <img
                    src={FlagIcon}
                    alt="flag"
                    className="h-5 w-7 object-contain"
                  />
                </div>

                {/* Phone Input */}
                <Input
                  type="tel"
                  placeholder={t("01-xxxxxxxx")}
                  value={deliveryBoyPhone}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || /^[0-9]*$/.test(value)) {
                      setDeliveryBoyPhone(value);
                    }
                  }}
                  maxLength={getMaxLength(deliveryBoyPhone)}
                  className="h-11 flex-1 rounded-lg border-gray-300 focus:border-primaryBlue focus:ring-1 focus:ring-primaryBlue"
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default DeliveryBoy;